// Prettify for the code snippet image generator (owner 2026-10-13): Prettier, loaded only when the button is
// pressed (its own chunks), for the languages it knows. The other languages have no Prettify button.

/** the languages Prettier formats, by the tool's language key */
const PRETTIFIABLE = [ 'typescript', 'tsx', 'javascript', 'jsx', 'markup', 'css', 'scss', 'json', 'yaml', 'markdown' ];

export function canPrettify( language: string ): boolean {
  return PRETTIFIABLE.includes( language );
}

/** the parser and its plugins for one language; each import is a chunk of its own */
async function setup( language: string ): Promise<{ parser: string; plugins: any[] }> {
  const estree = () => import( 'prettier/plugins/estree' );
  switch ( language ) {
    case 'typescript':
    case 'tsx':
      return { parser: 'typescript', plugins: await Promise.all( [ import( 'prettier/plugins/typescript' ), estree() ] ) };
    case 'javascript':
    case 'jsx':
      return { parser: 'babel', plugins: await Promise.all( [ import( 'prettier/plugins/babel' ), estree() ] ) };
    case 'json':
      return { parser: 'json', plugins: await Promise.all( [ import( 'prettier/plugins/babel' ), estree() ] ) };
    case 'markup':
      return { parser: 'html', plugins: await Promise.all( [ import( 'prettier/plugins/html' ) ] ) };
    case 'css':
      return { parser: 'css', plugins: await Promise.all( [ import( 'prettier/plugins/postcss' ) ] ) };
    case 'scss':
      return { parser: 'scss', plugins: await Promise.all( [ import( 'prettier/plugins/postcss' ) ] ) };
    case 'yaml':
      return { parser: 'yaml', plugins: await Promise.all( [ import( 'prettier/plugins/yaml' ) ] ) };
    case 'markdown':
      return { parser: 'markdown', plugins: await Promise.all( [ import( 'prettier/plugins/markdown' ) ] ) };
    default:
      throw new Error( 'No formatter for ' + language );
  }
}

/** The code formatted (two spaces, single quotes, a line of 80); throws when the code does not parse. */
export async function prettify( code: string, language: string ): Promise<string> {
  const [ prettier, { parser, plugins } ] = await Promise.all( [ import( 'prettier/standalone' ), setup( language ) ] );
  const out = await prettier.format( code, {
    parser,
    plugins: plugins.map( p => ( p as any ).default || p ),
    printWidth: 80,
    tabWidth: 2,
    singleQuote: true,
  } );
  return out.replace( /\n+$/, '' );
}
